import React, { useState, useEffect, useRef } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import { useParams } from "react-router-dom";
export default function ProductDetails() {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [productData, setProductData] = useState([]);
    const [colorData, setColorData] = useState([]);
    const [sizeData, setSizeData] = useState([]);
    const [ageData, setAgeData] = useState([]);
    const [selectedSize, setSelectedSize] = useState(null);
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedMrp, setSelectedMrp] = useState(0);
    const [selectedPrice, setSelectedPrice] = useState(0);
    const [quantity, setQuantity] = useState(1);
    const [mainImage, setMainImage] = useState();
    const [guideImage, setGuideImage] = useState();
    const [openSizeGuide, setOpenSizeGuide] = useState(false);
    useEffect(() => {
        fetchProductData();
        fetchCategoryData();
    }, []);
    const fetchCategoryData = async () => {
        setLoading(true);
        try {
            const [color, size, age] = await Promise.all([
                makeRequest("get", webEndPoint + "product-color/product/" + id),
                makeRequest("get", webEndPoint + "product-size/product/" + id),
                makeRequest("get", webEndPoint + "product-age/product/" + id),
            ]);
            setColorData(color?.data || []);
            setSizeData(size?.data || []);
            setAgeData(age?.data || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (id) {
            fetchProductData();
        }
    }, [id]);
    const fetchProductData = async () => {
        if (!id) return;
        setLoading(true);
        try {
            let url = webEndPoint + "product/" + id;
            const response = await makeRequest("get", url);
            if (response) {
                setProductData(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const increaseQty = () => setQuantity(prev => prev + 1);
    const decreaseQty = () => {
        if (quantity > 1) setQuantity(prev => prev - 1);
    };
    const showGuideModal = (value) => {
        setGuideImage(value);
        setOpenSizeGuide(true);
    }
    const handleShare = async () => {
        const shareData = {
            title: productData.product_name,
            text: "Check out this product!",
            url: window.location.href
        }
        try {
            if (navigator.share) {
                await navigator.share(shareData);
            } else {
                await navigator.clipboard.writeText(window.location.href);
                alert("Link copied to clipboard!");
            }
        } catch (err) {
            console.log("Share failed:", err);
        }
    };
    return (
        <div className="page-container">
            <Header />
            <Breadcrumb />
            {loading && (
                <div className="glass-loader">
                    <div className="modern-spinner"></div>
                </div>
            )}
            <div className="product-container">
                <div className="image-section">
                    <img src={mainImage ? mainImage : colorData[0]?.image_url} alt="product" className="main-image" />
                    <div className="thumbnail-row">
                        {colorData?.map((item) => (
                            <img key={item.rfId} src={item.image_url} alt={item.color_name} onClick={() => setMainImage(item.image_url)} className="thumb-img" />
                        ))}
                    </div>
                </div>
                <div className="details-section">
                    <h2>{productData.product_name}</h2>
                    <p className="brand">Brand: {productData.brand_name}</p>
                    <p className="category">{productData.maincategory_name}</p>
                    <div className="price-section">
                        {selectedPrice > 0 && <span className="price">₹{selectedPrice}</span>}
                        {selectedMrp > 0 && <span className="mrp">₹{selectedMrp}</span>}
                    </div>
                    {ageData?.length > 0 &&
                        <div className="options">
                            <h4>Select Age</h4>
                            {ageData?.map((item) => (
                                <button key={item.rfId}
                                    className={selectedSize === item.rfId ? "active" : ""}
                                    onClick={() => { setSelectedSize(item.rfId); setSelectedPrice(item?.price); setSelectedMrp(item?.mrp) }}>{item.age_name}
                                </button>
                            ))}
                        </div>
                    }
                    {sizeData?.length > 0 &&
                        <div className="options">
                            <h4>Select Age</h4>
                            {sizeData?.map((item) => (
                                <button key={item.rfId}
                                    className={selectedSize === item.rfId ? "active" : ""}
                                    onClick={() => { setSelectedSize(item.rfId); setSelectedPrice(item?.price); setSelectedMrp(item?.mrp) }}>{item.size_name}
                                </button>
                            ))}
                        </div>
                    }
                    <div className="option-group">
                        <h4>Quantity</h4>
                        <div className="quantity-box">
                            <button onClick={decreaseQty}>-</button>
                            <span>{quantity}</span>
                            <button onClick={increaseQty}>+</button>
                        </div>
                    </div>
                    <div className="description">
                        <h4>Description</h4>
                        <p>{productData.product_description}</p>
                    </div>
                    <div className="action-buttons">
                        <button className="add-to-cart">Add to Cart</button>
                        <button className="share-btn" onClick={handleShare}>Share</button>
                        <button className="guide-btn" onClick={() => showGuideModal(productData?.product_guide_image)}>View Size Guide</button>
                    </div>
                </div>
            </div>
            {openSizeGuide && (
                <div className="size-guide-overlay" onClick={() => setOpenSizeGuide(false)}>
                    <div className="size-guide-modal" onClick={(e) => e.stopPropagation()}>
                        <button className="closing-btn" onClick={() => setOpenSizeGuide(false)}>✕</button>
                        <img src={guideImage} alt="Size Guide" className="size-guide-image" />
                    </div>
                </div>
            )}
            <Footer />
        </div>
    )
}